/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading components
 * -----------------------------------------------------------------------------------------------------------
 */
import PostOffice from '../PostOffice'
import NewPostOffice from '../NewPostOffice'
import EditPostOffice from '../EditPostOffice'
import CopyPostOffice from '../CopyPostOffice'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Define component
 * -----------------------------------------------------------------------------------------------------------
 */
export default [
  {
    path: '/post-offices',
    name: 'post-offices',
    component: PostOffice
  },
  {
    path: '/post-offices/create',
    name: 'create-post-offices',
    component: NewPostOffice
  },
  {
    path: '/post-offices/:id/edit',
    name: 'edit-post-offices',
    component: EditPostOffice
  },
  {
    path: '/post-offices/:id/copy',
    name: 'copy-post-offices',
    component: CopyPostOffice
  }
]



// WEBPACK FOOTER //
// ./src/components/postOffice/routes/index.js